module.exports = __webpack_public_path__ + "static/media/tettigonia_caudata_003_APA.d5784690.png";